import React from 'react';
import InfoIcon from '@material-ui/icons/InfoOutlined';

interface IProps {
    title: string;
    description: string;
    classNameForParentDiv?: string;
}

export const TooltipComponent: React.SFC<IProps> = (props: IProps) => {
    const { title, description, classNameForParentDiv } = props;

    return (

        <div className={classNameForParentDiv}>
            <div className='tooltip__body'>
                <div>
                    <span className='tooltip__title'><InfoIcon style={{ fontSize: 14 }} /> {title}</span>
                    <br />
                    <span className='tooltip__description'>{description}</span>
                </div>
            </div>
        </div>

    );
};
